function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { ReactComponent as CursorSvg } from "../../../../assets/svg/cursor.svg";
import { ReactComponent as EmptySearchSvg } from "../../../../assets/svg/emptySearch.svg";
import { ReactComponent as EnterSvg } from "../../../../assets/svg/enter.svg";
import { ReactComponent as EscSvg } from "../../../../assets/svg/esc.svg";
import { ReactComponent as GuidanceSvg } from "../../../../assets/svg/guidance.svg";
import { ReactComponent as SearchSvg } from "../../../../assets/svg/search.svg";
import useList from "../../../../utils/hooks/useList";
import { DeleteOutlined, LoadingOutlined } from '@ant-design/icons';
import { Divider, Empty, Input, Modal, Spin } from 'antd';
import { useEffect, useRef, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import useDebounce from "../../hooks/use-debounce";
import styles from "./index.module.css";
import ListItem from "./ListItem";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Search = Input.Search;
var getUserCode = function getUserCode() {
  var _user;
  var userData = localStorage.getItem('user');
  var user = null;
  if (userData) {
    try {
      user = JSON.parse(userData);
    } catch (_unused) {
      user = {};
    }
  }
  return ((_user = user) === null || _user === void 0 ? void 0 : _user.userCode) || '';
};
var getSearchHistory = function getSearchHistory() {
  var userCode = getUserCode();
  var history = userCode ? localStorage.getItem("searchHistory-".concat(userCode)) : null;
  var historyList = [];
  if (history) {
    try {
      historyList = JSON.parse(history);
    } catch (_unused2) {
      historyList = [];
    }
  }
  return historyList || [];
};
var saveSearchHistory = function saveSearchHistory(searchHistory) {
  var userCode = getUserCode();
  if (userCode) localStorage.setItem("searchHistory-".concat(userCode), JSON.stringify(searchHistory));
};
var addSearchTerm = function addSearchTerm(searchText) {
  var searchHistory = getSearchHistory();
  var uniqueHistory = searchHistory.filter(function (item) {
    return item !== searchText;
  });
  var updatedHistory = [searchText].concat(_toConsumableArray(uniqueHistory)).slice(0, 10);
  saveSearchHistory(updatedHistory);
};
export default function SearchModal(props) {
  var open = props.open,
    onModalOpen = props.onModalOpen,
    onCancel = props.onCancel,
    handleClick = props.handleClick;
  var _useState = useState(getSearchHistory()),
    _useState2 = _slicedToArray(_useState, 2),
    searchHistory = _useState2[0],
    setSearchHistory = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    searchText = _useState4[0],
    setSearchText = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedItem = _useState6[0],
    setSelectedItem = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isComposing = _useState8[0],
    setIsComposing = _useState8[1];
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    isReload = _useState10[0],
    setIsReload = _useState10[1];
  var searchInputRef = useRef(null);
  var itemRefs = useRef([]);
  var containerRef = useRef(null);
  var listData = useList({
    method: 'get',
    url: '/flow/core/query/order/search/v2',
    initialPage: {
      size: 20
    }
  });
  var data = listData.data,
    isEmpty = listData.isEmpty,
    scrollProps = listData.scrollProps,
    handleQuery = listData.handleQuery,
    loading = listData.loading,
    page = listData.page;
  var clearSearchHistory = function clearSearchHistory() {
    var userCode = getUserCode();
    localStorage.removeItem("searchHistory-".concat(userCode));
    setSearchHistory([]);
  };
  var scrollToView = function scrollToView(index) {
    if (itemRefs.current[index]) {
      itemRefs.current[index].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  };
  var _onSearch = useDebounce(function (value) {
    if (value) {
      handleQuery({
        key: value
      });
      setIsReload(false);
    }
  }, 200);
  var onClose = function onClose() {
    setSearchText('');
    onModalOpen(false);
    if (onCancel) {
      onCancel();
    }
  };
  useEffect(function () {
    var _searchInputRef$curre;
    (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 || _searchInputRef$curre.focus();
  }, []);
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(e) {
      var keyCode = e.keyCode;
      if (selectedItem == null) {
        return;
      }
      if (keyCode === 38) {
        if (selectedItem > 0) {
          setSelectedItem(function (prev) {
            var newIndex = prev - 1;
            scrollToView(newIndex);
            return newIndex;
          });
        }
      } else if (keyCode === 40) {
        if (selectedItem < data.length - 1) {
          setSelectedItem(function (prev) {
            var newIndex = prev + 1;
            scrollToView(newIndex);
            return newIndex;
          });
        }
      }
      if (e.key === 'Enter') {
        if (data) {
          var selectData = data[selectedItem];
          var _selectData$item = selectData.item,
            taskOrderId = _selectData$item.taskOrderId,
            flowOrderId = _selectData$item.flowOrderId;
          handleClick(taskOrderId, flowOrderId);
          addSearchTerm(searchText);
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedItem, data.length]);
  var handleCompositionStart = function handleCompositionStart() {
    setIsComposing(true);
  };
  var handleCompositionEnd = function handleCompositionEnd(e) {
    setIsComposing(false);
    var value = e.target.value;
    setSearchText(value);
    _onSearch(value);
  };
  return /*#__PURE__*/_jsxs(Modal, {
    width: 900,
    closable: false,
    confirmLoading: loading,
    className: styles.sendModal,
    open: open,
    destroyOnClose: true,
    onCancel: onClose,
    keyboard: true,
    maskClosable: true,
    footer: null,
    children: [/*#__PURE__*/_jsx(Search, {
      ref: searchInputRef,
      autoFocus: true,
      placeholder: "\u8BF7\u8F93\u5165\u5355\u636E\u540D\u79F0\u6216\u5355\u636E\u7F16\u53F7\u641C\u7D22",
      size: "large",
      allowClear: true,
      enterButton: /*#__PURE__*/_jsx(SearchSvg, {}),
      onSearch: function onSearch(value, event) {
        setSearchText(value);
        _onSearch(value);
      },
      className: styles.searchInput,
      onChange: function onChange(e) {
        var value = e.target.value;
        setIsReload(true);
        setSearchText(value);
        if (!isComposing) {
          _onSearch(value);
        }
      },
      value: searchText,
      onCompositionStart: handleCompositionStart,
      onCompositionEnd: handleCompositionEnd
    }), /*#__PURE__*/_jsxs("div", {
      className: searchHistory.length === 0 && searchText === '' ? '' : styles.searchContent,
      children: [searchHistory.length === 0 && searchText === '' ? /*#__PURE__*/_jsxs("div", {
        className: styles.guidance,
        children: [/*#__PURE__*/_jsx("h2", {
          className: styles.guidanceTitle,
          children: "\u6B22\u8FCE\u4F7F\u7528\u641C\u7D22\u5DE5\u5177"
        }), /*#__PURE__*/_jsx("p", {
          className: styles.guidanceSubTitle,
          children: "\u652F\u6301\u4E00\u952E\u8DF3\u8F6C\u5355\u636E\u8BE6\u60C5, \u5FEB\u901F\u89E6\u8FBE\u4EFB\u52A1\u5F00\u59CB\u65F6\u95F4\u3001\u5B8C\u6210\u8282\u70B9\u7B49\u5404\u4E2A\u73AF\u8282"
        }), /*#__PURE__*/_jsx(GuidanceSvg, {
          className: styles.guidanceSvg
        })]
      }) : null, searchHistory.length > 0 && searchText === '' ? /*#__PURE__*/_jsxs("div", {
        className: styles.historySearchContent,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.historySearchHeader,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.historySearchTitle,
            children: "\u6700\u8FD1\u641C\u7D22"
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.historySearchClear,
            onClick: clearSearchHistory,
            children: [/*#__PURE__*/_jsx(DeleteOutlined, {
              className: styles.clearIcon
            }), "\u6E05\u7A7A"]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.historySearchList,
          children: searchHistory.map(function (item, index) {
            return /*#__PURE__*/_jsx("div", {
              className: styles.label,
              onClick: function onClick() {
                setSearchText(item);
                _onSearch(item);
              },
              children: item
            }, "".concat(item, "-").concat(index));
          })
        })]
      }) : null, searchText !== '' ? /*#__PURE__*/_jsx("div", {
        className: styles.searchList,
        ref: containerRef,
        id: "scrollableDiv",
        children: /*#__PURE__*/_jsx(InfiniteScroll, _objectSpread(_objectSpread({
          dataLength: data.length
        }, scrollProps), {}, {
          style: {
            overflow: 'hidden'
          },
          loader: /*#__PURE__*/_jsx("div", {
            className: styles.loadingContent,
            children: /*#__PURE__*/_jsx(Spin, {
              indicator: /*#__PURE__*/_jsx(LoadingOutlined, {
                spin: true,
                className: styles.loadingIcon
              }),
              size: "large"
            })
          }),
          endMessage: !isReload ? /*#__PURE__*/_jsx("div", {
            className: styles.allText,
            children: "\u5DF2\u7ECF\u5C55\u793A\u5168\u90E8\u7ED3\u679C"
          }) : null,
          scrollableTarget: "scrollableDiv",
          children: !isEmpty && !isReload ? data.map(function (item, index) {
            return /*#__PURE__*/_jsx(ListItem, {
              data: item,
              index: index,
              selectedItem: selectedItem,
              ref: function ref(el) {
                if (el) {
                  itemRefs.current[index] = el;
                }
              },
              searchText: searchText,
              handleClick: handleClick
            });
          }) : !isReload && searchText !== '' && isEmpty ? /*#__PURE__*/_jsx(Empty, {
            className: styles.empty,
            image: /*#__PURE__*/_jsx(EmptySearchSvg, {}),
            description: '',
            children: /*#__PURE__*/_jsx("span", {
              className: styles.emptyText,
              children: "\u6682\u65E0\u641C\u7D22\u7ED3\u679C"
            })
          }) : null
        }))
      }) : null, searchText !== '' ? /*#__PURE__*/_jsxs("div", {
        className: styles.footer,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.footerItem,
          children: [/*#__PURE__*/_jsx(CursorSvg, {}), /*#__PURE__*/_jsx("span", {
            className: styles.footerItemText,
            children: "\u79FB\u52A8\u5149\u6807"
          })]
        }), /*#__PURE__*/_jsx(Divider, {
          type: "vertical"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.footerItem,
          children: [/*#__PURE__*/_jsx(EnterSvg, {}), /*#__PURE__*/_jsx("span", {
            className: styles.footerItemText,
            children: "\u9009\u62E9\u6761\u76EE"
          })]
        }), /*#__PURE__*/_jsx(Divider, {
          type: "vertical"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.footerItem,
          children: [/*#__PURE__*/_jsx(EscSvg, {}), /*#__PURE__*/_jsx("span", {
            className: styles.footerItemText,
            children: "\u5173\u95ED\u7A97\u53E3"
          })]
        })]
      }) : null]
    })]
  });
}